export default __webpack_public_path__ + "static/media/Error403.b66877c8.svg";